module.exports = __webpack_public_path__ + "static/media/toasty.00079519.wav";